import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SettingsService } from '../../../core/services/settings.service';
import { NotificationService } from '../../../core/services/notification.service';
import { OperatingHoursDto, HolidayDto } from '../../../core/models/operating-hours.model';

@Component({
  selector: 'app-hours-settings',
  imports: [CommonModule, FormsModule],
  templateUrl: './hours-settings.html',
  styleUrl: './hours-settings.scss',
})
export class HoursSettings implements OnInit {
  isLoading = false;
  isSaving = false;

  operatingHours: OperatingHoursDto = {
    id: '',
    weekdayOpen: '08:00',
    weekdayClose: '17:00',

    saturdayOpen: true,
    saturdayStart: '08:00',
    saturdayEnd: '13:00',

    sundayOpen: false,
    sundayStart: '09:00',
    sundayEnd: '12:00',

    holidays: [],
  };

  constructor(
    private settingsService: SettingsService,
    private notificationService: NotificationService,
  ) {}

  ngOnInit(): void {
    this.loadOperatingHours();
  }

  private loadOperatingHours(): void {
    this.isLoading = true;

    this.settingsService.getOperatingHours().subscribe({
      next: (settings) => {
        this.operatingHours = {
          ...settings,
          holidays: settings.holidays ?? [],
        };
        this.isLoading = false;
      },
      error: (error) => {
        this.notificationService.error(
          'Failed to load operating hours: ' +
            (error?.error?.message || error.message || 'Unknown error'),
        );
        this.isLoading = false;
      },
    });
  }

  saveOperatingHours(): void {
    this.isSaving = true;

    this.settingsService.updateOperatingHours(this.operatingHours).subscribe({
      next: (updatedSettings) => {
        this.operatingHours = {
          ...updatedSettings,
          holidays: updatedSettings.holidays ?? [],
        };
        this.notificationService.success('Operating hours saved successfully.');
        this.isSaving = false;
      },
      error: (error) => {
        this.notificationService.error(
          'Failed to save operating hours: ' +
            (error?.error?.message || error.message || 'Unknown error'),
        );
        this.isSaving = false;
      },
    });
  }

  addHoliday(): void {
    this.operatingHours.holidays.push({
      name: '',
      date: '',
    });
  }

  removeHoliday(index: number): void {
    this.operatingHours.holidays.splice(index, 1);
  }

  trackHoliday(index: number, holiday: HolidayDto): string {
    return `${holiday.date}-${index}`;
  }
}
